import moment from 'moment';

export function filterQueryParams (params) {
  const result = {};
  Object.keys(params).forEach((key) => {
    const val = params[key];
    // axios 中过滤了 null 和 undefined
    if (val === null || typeof val === 'undefined') {
      return;
    }
    result[key] = val;
  });

  return result;
}

export function isEmptyObject (obj) {
  if (obj !== null && obj !== undefined) {
    return Object.keys(obj).length === 0;
  }
  return true;
}

export function isSuccess (response) {
  return response.result === 'success';
}

export function convertTimeStamp (timeStamp, format = 'HH:mm') {
  return moment.unix(timeStamp).format(format);
}

export function decodeUtf8 (arrayBuffer) {
  return new TextDecoder('utf-8').decode(arrayBuffer);
}

/**
 * 判断变量是否为对象
 * @param {*} obj
 * @returns
 */
export const isObject = (obj) => obj !== undefined && obj !== null && obj.constructor === Object;
